angular.module('empower.claimPerformanceReport')
    .service('claimPerformanceReportService', ['$rootScope', '$filter', '$q', 'httpService',
        function ($rootScope, $filter, $q, httpService) {
            return {
                getPolicyYearList: getPolicyYearList,
                getCPRReport: getCPRReport,
                getCPRReportPdf: getCPRReportPdf,
                getCPREmployerInfo: getCPREmployerInfo
            };

            function getCPREmployerInfo(policyId) {
                var def = $q.defer(),
                    apiTarget = "api/report/getcpremployerinfo",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };

            function getPolicyYearList(policyId) {
                var def = $q.defer(),
                    apiTarget = "api/policies/getlistpolicyyear",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };

            function getCPRReport(policyId, finishDate, asAt) {
                var def = $q.defer(),
                    apiTarget = "api/policies/getcprreport",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId,
                        finishDate: finishDate,
                        AsAt: asAt,
                    });

                httpService.httpRequest(apiTarget, values).then(function (data) {  // this is only run after $http completes
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        $rootScope.getRecentPoliciesAndClaims();
                        def.resolve(angular.fromJson(data)); // PolicyDetails
                    } else {
                        def.reject();
                    }
                });

                return def.promise;
            };


            function getCPRReportPdf(policyId, finishDate, policyNumber, asAt) {
                var def = $q.defer(),
                    apiTarget = "api/report/generatecprreport",
                    values = JSON.stringify({
                        Identifier: $rootScope.user.Identifier,
                        SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                        PolicyId: policyId,
                        finishDate: finishDate,
                        AsAt: asAt,
                    });
                var options = { responseType: 'arraybuffer' };
                httpService.httpRequest(apiTarget, values, 'GET', options).then(function (data) {
                    if (angular.isDefined(data.File)) {
                        $rootScope.getRecentPoliciesAndClaims();
                        var file = new Blob([data.File], { type: 'application/pdf' });
                        var fileName = 'CPRReport_' + policyNumber.trim() + '.pdf';
                        saveAs(file, fileName);
                        def.resolve();
                    }
                    else
                        def.reject();
                });

                return def.promise;
            }
        }]);